import { useState } from "react";
import { Card } from "../../components/ui/Card";
import { Eyebrow } from "../../components/ui/Eyebrow";
import { Chip } from "../../components/ui/Chip";
import { CtaButton } from "../../components/ui/Button";
import { useSessionLogging } from "./useSessionLogging";
import { ExerciseRow } from "./ExerciseRow";
import { ExercisePicker } from "../exercises/ExercisePicker";

export function SessionsPage() {
  const {
    programName,
    days,
    selectedDay,
    setSelectedDay,
    exercises,
    lastByExercise,
    loggedByExercise,
    loading,
    logSet,
    generateFullProgram,
    addExerciseToProgram,
    removeExercise,
  } = useSessionLogging();
  const [generating, setGenerating] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);

  if (loading) return null;

  if (!programName) {
    return (
      <>
        <Card>
          <Eyebrow>Entreno de hoy</Eyebrow>
          <p className="mb-3 text-sm text-muted">
            Todavía no tienes ningún programa activo. Genera un programa completo de 4 días para
            recomposición corporal (pecho 2x/semana, foco en cintura) listo para empezar hoy
            mismo, o construye el tuyo eligiendo ejercicios uno a uno.
          </p>
          <CtaButton
            disabled={generating}
            onClick={async () => {
              setGenerating(true);
              try {
                await generateFullProgram();
              } finally {
                setGenerating(false);
              }
            }}
          >
            {generating ? "Generando…" : "Generar mi programa (4 días)"}
          </CtaButton>
          <button
            onClick={() => setPickerOpen(true)}
            className="mt-2.5 w-full rounded-inner border border-line py-3 font-mono text-[11px] uppercase tracking-[0.1em] text-accent-bright"
          >
            + Construir el mío desde cero
          </button>
        </Card>
        {pickerOpen && (
          <ExercisePicker
            onClose={() => setPickerOpen(false)}
            onAdd={addExerciseToProgram}
            dayLabel={null}
          />
        )}
      </>
    );
  }

  return (
    <>
      <Card>
        <Eyebrow right={<Chip>{exercises.length} ejercicios</Chip>}>Entreno de hoy</Eyebrow>
        <div className="mb-3 font-display text-2xl font-extrabold uppercase">{programName}</div>

        {days.length > 1 && (
          <div className="mb-3 flex gap-1.5 overflow-x-auto">
            {days.map((d) => (
              <button
                key={d}
                onClick={() => setSelectedDay(d)}
                className={`shrink-0 rounded-full border px-3 py-1.5 font-mono text-[10px] tracking-[0.06em] ${
                  selectedDay === d ? "border-accent bg-accent text-white" : "border-line text-muted"
                }`}
              >
                {d}
              </button>
            ))}
          </div>
        )}

        {exercises.map((item) => (
          <ExerciseRow
            key={item.id}
            item={item}
            last={lastByExercise[item.exercise_id]}
            logged={loggedByExercise[item.exercise_id]}
            onLog={(values) => logSet(item.exercise_id, values)}
            onRemove={() => removeExercise(item.id)}
          />
        ))}
        <button
          onClick={() => setPickerOpen(true)}
          className="mt-3 w-full rounded-inner border border-line py-3 font-mono text-[11px] uppercase tracking-[0.1em] text-accent-bright"
        >
          + Añadir ejercicio
        </button>
      </Card>
      {pickerOpen && (
        <ExercisePicker
          onClose={() => setPickerOpen(false)}
          onAdd={addExerciseToProgram}
          dayLabel={selectedDay}
        />
      )}
    </>
  );
}
